// CreditNova MSAL Configuration
import { PublicClientApplication, Configuration, LogLevel } from '@azure/msal-browser';

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID || '',
    // Use 'organizations' to allow any Azure AD account (multi-tenant B2B)
    // Users from other companies can sign in with their work accounts
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
    knownAuthorities: ['login.microsoftonline.com'],
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            if (import.meta.env.DEV) console.info(message);
            break;
          case LogLevel.Verbose:
            if (import.meta.env.DEV) console.debug(message);
            break;
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Info : LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

// Create MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL
msalInstance.initialize().catch((error) => {
  console.error('MSAL initialization failed:', error);
});

// Login request scopes - basic OIDC scopes only
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'offline_access'],
};

// API request scopes
// Use the explicit scope exposed in "Expose an API" so personal Microsoft accounts
// receive a proper JWT (not an opaque Graph token). The .default shorthand doesn't
// resolve correctly for personal accounts.
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID || '';
export const apiRequest = {
  scopes: [`api://${clientId}/access_as_user`],
};

export default msalInstance;

